<template>
  <!-- eslint-disable max-len -->
  <div class="Table">
    <div class="row">
      <div class="col category">
        <span class="bold">What Personal Information Do We Collect ?</span>
        <img alt="Document icon" src="../assets/document.png">
      </div>
      <div class="col information">
        <ul>
          <li>
            <span class="bold">Contact Information</span>
            (such as name, phone number, fax number, postal address or e-mail address)
          </li>
          <li>
            <span class="bold">Account/Registration Information</span>
            (such as user name and password, profile picture, reminder questions and answers, and communications preferences)
          </li>
          <li>
            <span class="bold">Payment Information</span>
            (such as name, billing address, and credit card or debit card information, e.g., when
            making a purchase)
          </li>
          <li>
            <span class="bold">Demographic Information</span>
            (such as age, gender race, income, occupation, sexual orientation, relationship status, and information about your household/family status, including your household size and the length of time at your residence)
          </li>
          <li>
            <span class="bold">Online Identifiers</span>
            (such as IP address, internal and third party identifiers, advertising identifiers and
            device information like unique device ID)
          </li>
          <li>
            <span class="bold">Location Data</span>
            (like your address, city, and zip code, collected in limited circumstances; we may also derive your approximate location from your IP address)
          </li>
          <li>
            <span class="bold">Online Activity Information</span>
            (such as browsing history, information on how you interact with our Services-e.g., which
            articles or ads you click on, whether you click on links in our e-mails, and your
            interactions with social media platform features)
          </li>
          <li>
            <span class="bold">
              Inferences about Your Interests, Preferences and other Behavioral Data
            </span>
            (such as hobbies and interests -e.g., your favorite foods, purchases or recipes, and consuming tendencies)
          </li>
          <li>
          <span class="bold">
              Other Personal Information that Consumers Voluntarily Choose to Provide
            </span>
             (such as photos, comments, or Personal Information about others that you post or submit on our Services)
          </li>
        </ul>
        <a class="more" href="#personal">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">Where/How Do We Collect Personal Information?</span>
        <img alt="Devices icon" src="../assets/devices.png">
      </div>
      <div class="col information">
        <ul>
          <li>
            <span class="bold">From You:</span>
            <ul>
              <li>Through the Services (e.g., when you sign up for a newsletter, register an account to access the Services, or make a purchase).</li>
              <li>Offline (e.g., when you place an order over the phone, or contact customer service).</li>
            </ul>
          </li>

          <li>
            <span class="bold">From Your Device:</span>
            <ul>
              <li>
                <span class="bold">From Cookies & Other Technologies</span> (Personal Information stored
                on your browser, which tell us your browser, device information, IP address,
                and how you interact with the Services).
              </li>
            </ul>
          </li>
          <li>
            <span class="bold">From Others:</span>
            <ul>
              <li>Publicly available databases</li>
              <li>Joint marketing partners, when they share the Personal Information with us.</li>
            </ul>
          </li>
        </ul>
        <a class="more" href="#collect">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">How Do We Use Personal Information?</span>
        <img alt="Gear icon" src="../assets/gear.png">
      </div>
      <div class="col information">
        <span class="bold">We use your information:</span>
        <ul>
          <li>
            To provide you with the<span class="bold"> functionality of the Services and fulfilling your requests</span>
          </li>
          <li>To provide you with<span class="bold"> our newsletter and/or other marketing materials</span></li>
          <li>To analyze Personal Information for<span class="bold"> business reporting and providing personalized services.</span></li>
          <li>
            To allow you to participate in<span class="bold"> sweepstakes, contests, or other promotions.</span>
          </li>
          <li>When aggregating and/or anonymizing Personal Information.</li>
          <li>
            To<span class="bold"> accomplish our business purposes</span> (e.g., data analysis, fraud and security, and more).
          </li>
          <li>
          To <span class="bold">restrict certain portions of our website to visitors from the United States.</span>
          </li>
        </ul>
        <a class="more" href="#use">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">Who Do We Share Personal Information With?</span>
        <img alt="Gear icon" src="../assets/connections.png">
      </div>
      <div class="col information">
        <ul>
          <li>With <span class="bold">our parent company, Synapse Group, Inc.</span></li>
          <li>With <span class="bold">our affiliates</span></li>
          <li>With our third party <span class="bold">service providers.</span></li>
          <li>With <span class="bold">third-party sponsors</span> of sweepstakes, contests, and similar promotions.</li>
          <li>With <span class="bold">third-party providers</span> of health-care related services.</li>
          <li>When <span class="bold">required by law</span></li>
          <li>With a <span class="bold">buyer of all or part of our business.</span></li>
          <li>With other third parties, <span class="bold">when we have your consent.</span></li>
        </ul>
        <a class="more" href="#share">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">How Can You Control Our Use of Personal Information?</span>
        <img alt="Lock icon" src="../assets/lock.png">
      </div>
      <div class="col information">
        You can tell us how we can use your Personal Information by clicking on the links below:
        <ul>
                                <li><span class="bold">Text/SMS/mobile messages from us.</span> If you no longer want to receive text/SMS/mobile messages from us on a going-forward basis, you may opt out by replying “STOP” to the message.</li><br />
              <li>If you prefer not to receive promotions from Synapse Group Inc., or if you want to opt-out of any sharing of your offline Personal Information with our affiliates or third parties, please click <a
              href="http://privacy.synapsegroupinc.com/optout.html"
              target="_blank"
              rel="noopener noreferrer"
              >here</a
            >.</li><br />
              <li>To request deletion or access to your Personal Information click <a
              href="http://privacy.synapsegroupinc.com/optout.html"
              target="_blank"
              rel="noopener noreferrer"
              >here</a
            >.  </li>
                           </ul>
        <a class="more" href="#control">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">Children's Privacy</span>
        <img alt="Child icon" src="../assets/child.png">
      </div>
      <div class="col information">
        We do not knowingly collect Personal Information from anyone under the age of 16.
        <a class="more" href="#children">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">Rights for Our California Residents</span>
        <img alt="California icon" src="../assets/california.png">
      </div>
      <div class="col information">
        You have all the rights listed above. In addition, if you’re a resident of California, you have the right to:
               <br />
        <br />
               <ul>
          <li>
            <span class="bold">Request that we not sell your Personal Information.</span>
            <ul>
              <li>If you would like to exercise this right, click
              <a href="https://privacyportalde-cdn.onetrust.com/dsarwebform/2159c482-749a-49db-916b-475017a9efa5/424d0d20-a84d-41ed-9a27-379d31f2551d.html" target="_blank" rel="noopener noreferrer">here</a>
              </li>
            </ul>
          </li>
           <br />
        <br />
          <li>
            <span class="bold">
              Make a “Shine the Light” inquiry, and we will disclose to you whether we share your Personal Information with third parties for their direct marketing purposes.
            </span>
            <ul>
              <li>If you would like to exercise this right, e-mail us at <a href="mailto:privacy@synapsemail.com">privacy@synapsemail.com</a>.
              </li>
            </ul>
          </li>
        </ul>
        <a class="more" href="#section4">MORE</a>
      </div>
    </div>

    <div class="row">
      <div class="col category">
        <span class="bold">How You Can Learn More</span>
        <img alt="Lightbulb icon" src="../assets/lightbulb.png">
      </div>
      <div class="col information">
        Click <a href="#personal">here</a> to read our full <a href="#personal">Privacy Statement</a>
        <br />
        <br />
        Still can&apos;t find what you&apos;re looking for about our data privacy practices? Don&apos;t worry, just reach out to us via e-mail <a href="mailto:privacy@synapsemail.com">privacy@synapsemail.com</a> and we will get back to you!
        <a class="more" href="#learn">MORE</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Table',
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.Table {
  border: 1px solid darkgray;
}
.row {
  display: flex;
  flex-direction: column;

  @media (min-width: 576px) {
    flex-direction: row;
  }
}

.col.category {
  padding: 1em 0.5em;
  border-bottom: 1px dashed darkgray;

  img {
    display: block;
    margin: auto;
    width: 100px;
    height: auto;
  }

  @media (min-width: 576px) {
    width: 400px;
    border-bottom: 1px solid darkgray;
    border-right: 1px dashed darkgray;
  }
}

.col.information {
  padding: 1em 0.5em;
  border-bottom: 1px solid darkgray;

  ul {
    margin: 0;
  }

  a.more {
    width: 100%;
    display: block;
    text-align: right;
  }

  @media (min-width: 576px) {
    width: 400px;
    flex-grow: 1;
  }
}
</style>
